import axios from "./index";

class financial {



  //获取电子票渠道结算单
  static getElectronicFinancialList(params) {
    return axios.get("/app-finance/electronic/distributor/bill/page/list", { params: params });
  }

  //获取电子票渠道结算单明细
  static getElectronicFinancialDetail(params) {
    return axios.get("/app-finance/electronic/distributor/bill/detail/page/list", { params: params });
  }

  //删除电子票渠道账单
  static delElectronicDistributor(code) {
    return axios.post(`/app-finance/electronic/distributor/bill/del/${code}`);
  }

  //电子票和现金票渠道创建对账单
  static createElectronicChannelBill(params) {
    return axios.post('/app-finance/electronic/distributor/data/distributor/make', params)
  }

  //电子票和现金票渠道创建前一天对账单
  static createDayChannelBill(params) {
    return axios.get('/app-finance/electronic/distributor/data/toffLineTicketMake', params)
  }

  //获取渠道结算单
  static getFinancialList(params) {
    return axios.get("/app-finance/distributor/bill/page/list", { params: params });
  }
  //获取渠道结算单明细
  static getFinancialDetail(params) {
    return axios.get("/app-finance/distributor/bill/detail/page/list", { params: params });
  }
  //渠道结算单明细数量统计
  static getDistributorCount(params) {
    return axios.get("/app-finance/distributor/bill/detail/ticket-type-count", { params: params });
  }
  //删除渠道账单
  static delDistributor(code) {
    return axios.post(`/app-finance/distributor/bill/del/${code}`);
  }
  //渠道结算单明细确认对帐
  static distributorFinish(params) {
    return axios.post(`/app-finance/distributor/bill/confirm/${params}`);
  }
  //获取供应对账单列表
  static getSupplierList(params) {
    return axios.get("/app-finance/supplier/bill/page/list", { params: params });
  }
  //渠道创建对账单
  static createChannelBill(params) {
    return axios.post('/app-finance/distributor/data/distributor/make', params)
  }
  //供应订单列表数量
  static getSupplierBillCount() {
    return axios.get("/app-finance/supplier/bill/bill-type-count");
  }
  //获取供应对账单明细
  static getSupplierDetail(params) {
    return axios.get("/app-finance/supplier/bill/detail/page/list", { params: params });
  }
  //供应结算单明细数量统计
  static getSupplierTicketCount(params) {
    return axios.get("/app-finance/supplier/bill/detail/ticket-type-count", { params: params });
  }
  //供应创建对账单
  static createBill(params) {
    return axios.post(`/app-finance/supplier/bill/manually/create`, params, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

    //供应创建对账单新
    static createSupplyBill(params) {
        return axios.post('/app-finance/supplier/bill/supplier/make', params)
    }

  //供应模板下载
  static templateDownload() {
    return axios.get("/app-finance/supplier/bill/download/template");
  }
  //删除供应
  static delSupplier(code) {
    return axios.post(`/app-finance/supplier/bill/del/${code}`);
  }
  //对账完成
  static supplierFinish(params) {
    return axios.post(`/app-finance/supplier/bill/finish/${params}`);
  }
  //删除供应明细
  static delSupplierDetail(code) {
    return axios.post(`/app-finance/supplier/bill/detail/del/import/${code}`);
  }
}

export default financial;
